import sha512 from 'crypto-js/sha512';
import hex from 'crypto-js/enc-hex';

export default class CryptoService {
  public static encode(string: string): string {
    return sha512(string).toString(hex);
  }
}
